import createApolloClient, { AUTH_TYPE } from "@covertree/apollo";

// typePolicies is an optional parameter that allows you to define custom keyFields for each type to use instead of the default "id" field.
// It will enable Apollo Client to identify the cache object by a different field than the default "id" field.
const typePolicies = {
  Policyholder: {
    keyFields: ["policyholderLocator"],
  },
  Policy: {
    keyFields: ["policyLocator"],
  },
  PolicyNote: {
    keyFields: ["noteLocator"],
  },
  PolicyDocument: {
    keyFields: ["documentLocator"],
  },
  Renewal: {
    keyFields: ["renewalLocator"],
  },
};

export const { client, useApolloNetworkStatus } = createApolloClient(
  AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
  typePolicies
);
